import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {PostFiveStars, PostFiveStarsModel, PostFiveStarsParams} from 'domain/usecases';

export class RemotePostFiveStars implements PostFiveStars {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostFiveStarsModel>,
	) {}

	async post(params: PostFiveStarsParams): Promise<PostFiveStarsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
